module.exports = __webpack_public_path__ + "static/img/portrait.326bbfe.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/pic/portrait.png
// module id = jPwe
// module chunks = 3